import React from 'react'

import ExcelDropArea from '../../components/excel-drop-area/excel-drop-area'
import { GenerateSectionProps } from './appconfig.types'

const AppConfigSection = (props: GenerateSectionProps) => {
  return (
    <div className='bordered4 border-dashed m-2 p-2 border-radius'>
      <p className='font-20 sourcesansprosemibold color-primary p-2'>
        {props.sectionTitle}
      </p>
      <div className='h-auto w-auto mt-2'>
        <ExcelDropArea
          processFileHandler={props.processFileHandler}
          title={props.dropAreaTitle}
        />
      </div>
    </div>
  )
}

export default AppConfigSection
